import React, { Component } from 'react';
import swal from 'sweetalert';
import axios from 'axios';
 

const letras={
    textShadow: "2px 2px 5px #000000"
}
const estilo2={ 

background: "url(./images/Banner3background.jpg) no-repeat top center",
backgroundSize:"cover",
backgroundPositionY: "-90px",
height:"1000px"
}
const estilo3={
width:"180px",
height:"90px"
}


class Alfombras extends Component{
state={
    nombre:'',
    empresa:'',
    telefono:'',
    correo:'',
    error:false,
    enviado:false
}
nombrePersona = e =>{
    this.setState({nombre:e.target.value})

    if(e.target.value==='')
    {
        this.setState({error:true});
    }
    else{

    }
}
empresaPersona= e => {
    this.setState({empresa:e.target.value})
}
correoPersona= e => {
    this.setState({correo:e.target.value})
}
telefonoPersona= e => {
    this.setState({telefono:e.target.value})
}


Cotizacion = e =>{
    e.preventDefault();
    const {nombre,telefono,correo,empresa} = this.state;
    if(nombre==='' || telefono ===''  || correo==='' || empresa ===''){
        this.setState({error:true});
        return;
    }
    this.setState({error:false})

    const API_HOST_URL = process.env.REACT_APP_API_HOST_URL;
    
 
    axios.get('https://api.ipify.org?format=json')
    .then(res => {
        axios.post(`${API_HOST_URL}MyWsMobil/api/SolicitudUsuarioWeb/SolicitarInfo/`,{
            Correo:correo,
            Tipo:'Solicitud',
            Nombres:nombre,
            Apellidos:' ',                
            Telefono:telefono,
            NombreEmpresa:empresa,
            Log:{
                IdHostCreacion:res.data.ip
            }
        }
        ,{
            headers:{
                'Content-Type': 'application/json',
                'access-control-allow-origin':'*', 
            } 
        }
        )
        .then(res => {
            if(res.status===200){
                console.log(res)
                if(res.data.Resultado){
                    this.setState({enviado:true});
                    swal("Mensaje!", res.data.Mensaje, "success");

                }
                else{
                    swal("Mensaje!", res.data.Mensaje, "error");
                }
                
            }
            else{
                swal("Mensaje!", "Ocurrio un error", "error");
                console.log(res);
            }
            
        })
        .catch(err =>{
            swal("Mensaje!",err.message, "error");
            console.log(err);
        }) 
      });

}



    nombreRef=React.createRef();
    empresaRef=React.createRef();
    telefonoRef=React.createRef();
    emailRef=React.createRef();
 

    Suscribirme = (e) =>{
        e.preventDefault();

        const API_HOST_URL = process.env.REACT_APP_API_HOST_URL;

        axios.get('https://api.ipify.org?format=json')
			.then(res => {
                axios.post(`${API_HOST_URL}MyWsMobil/api/SolicitudUsuarioWeb/SolicitarInfo/`,{
                    Correo:this.emailRef.current.value,
                    Tipo:'Solicitud',
                    Nombres:this.nombreRef.current.value,
                    Apellidos:' ',                
                    Telefono:this.telefonoRef.current.value,
                    NombreEmpresa:this.empresaRef.current.value,
                    Log:{
                        IdHostCreacion:res.data.ip
                    }
                }
                ,{
                    headers:{
                        'Content-Type': 'application/json',
                        'access-control-allow-origin':'*', 
                    } 
                }
                )
                .then(res => {
                    if(res.status===200){
                        console.log(res)
                        if(res.data.Resultado){
                            swal("Mensaje!", res.data.Mensaje, "success");
        
                        }
                        else{
                            swal("Mensaje!", res.data.Mensaje, "error");
                        }
                    }
                    else{
                        swal("Mensaje!", "Ocurrio un error", "error");
                        console.log(res);
                    }
                    
                })
                .catch(err =>{
                    swal("Mensaje!",err.message, "error");
                    console.log(err);
                }) 
              });
              
        //leer los datos por ref
        //debugger;


    
        
        }

    render(){
         const {error} =this.state;
         const {enviado} =this.state;
        return(
            
        <div>
            <header id="header" style={estilo2}>
        
                <nav id="navigation" className="navbar scrollspy">
        
                    <div className="container">
        
                        <div className="navbar-brand">
                            <a href="/alfombras"><img src="images/imagotipodisdel.png" alt="Logo"  style={estilo3} /></a>
                        </div>
                        <ul className="nav navbar-nav">
                            <li className="active"><a href="#header" className="smooth-scroll">Inicio</a></li>
                            <li><a href="#Tipo1" className="smooth-scroll">Tipo 1</a></li>
                            <li><a href="#Tipo2" className="smooth-scroll">Tipo 2</a></li>
                            <li><a href="#Tipo3" className="smooth-scroll">Tipo 3</a></li>
                            <li><a href="#Tipo4" className="smooth-scroll">Tipo 4</a></li>
                             
                            
                            <li className="menu-btn"><a href="#cotizar" className="smooth-scroll">solicitar cotización</a></li>
                        </ul>
                    </div>
                </nav>
        
                <div className="header-content">
                    <div className="container">
                        <div className="header-heading-title">
        
                            <div className="col-sm-6 col-md-7 col-lg-6">
                                <div className="header-txt">
                                    <div className="header-txt-heading">
                                    <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/> 
                                    </div>
                                    <div className="header-txt-btn smooth-scroll">
                                        <a href="#cotizar" className="smooth-scroll"> <h1><strong style={letras}>¡Dale la bienvenida a tus clientes!</strong></h1><span className="btn-custom">Cotizar</span></a>        
                                    </div>
                                </div>
                            </div>
        
        
                        </div>
                        <div className="row header-row">
                            <div className="col-sm-6 col-md-7 col-lg-6">
                                <div className="header-txt">
                                     
                                     
                                    
                                </div>
                            </div>
        
                        </div>
        
                    </div>
        
                </div>
        
            </header>
        
            <div className="padding-top80" id="Tipo1">


                <div className="container">
                    <div className="row padding-bottom20">                    
                        <div className="col-sm-12"> 
                            <div className="affa-feature-img">
                                <img src="images/01Alfombrasparainteriores.jpg" alt="01Alfombrasparainteriores"/>                                
                            </div>
                        </div>
                    </div>       
                </div>
                <div  className="hr-line-dashed">  </div>


                <div className="container">
                    <div className="row padding-bottom20" >
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="affa-col-txt">
                                    <img src="images/1SuperScrapeSquare1.jpg" alt="1SuperScrapeSquare1" />
                                    <img src="images/1SuperScrapeSquare2.jpg" alt="1SuperScrapeSquare2" />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="affa-feature-img">
                                    <img src="images/1SuperScrapeSquare4.jpg" alt="1SuperScrapeSquare4" />
                                    <img src="images/1SuperScrapeSquare3.jpg" alt="1SuperScrapeSquare3" />
                                </div>
                            </div>
                        </div>         
                    </div>
                </div>
                <div  className="hr-line-dashed">  </div>

                <div className="container">
                    <div className="row padding-bottom20" >
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="affa-col-txt">
                                    <img src="images/23MNomadparatrafico1.jpg" alt="23MNomadparatrafico1" />
                                    <img src="images/23MNomadparatrafico2.jpg" alt="23MNomadparatrafico2" />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="affa-feature-img">
                                    <img src="images/23MNomadparatrafico4.jpg" alt="23MNomadparatrafico4" />
                                    <img src="images/23MNomadparatrafico3.jpg" alt="23MNomadparatrafico3" />
                                </div>
                            </div>
                        </div>         
                    </div>
                </div>
                <div  className="hr-line-dashed">  </div>


                <div className="container">
                    <div className="row padding-bottom20" >
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="affa-col-txt">
                                    <img src="images/365003MCarpet1.jpg" alt="365003MCarpet1" />
                                    <img src="images/365003MCarpet2.jpg" alt="365003MCarpet2" />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="affa-feature-img">
                                    <img src="images/365003MCarpet4.jpg" alt="365003MCarpet4" />
                                    <img src="images/365003MCarpet3.jpg" alt="365003MCarpet3" />
                                </div>
                            </div>
                        </div>         
                    </div>
                </div>
                <div  className="hr-line-dashed">  </div>




                <div className="container">
                    <div className="row padding-bottom20" >
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="affa-col-txt">
                                    <img src="images/5Andersen1.jpg" alt="5Andersen1" />
                                    <img src="images/5Andersen2.jpg" alt="5Andersen2" />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="affa-feature-img">
                                    <img src="images/5Andersen4.jpg" alt="5Andersen4" />
                                    <img src="images/5Andersen3.jpg" alt="5Andersen3" />
                                </div>
                            </div>
                        </div>         
                    </div>
                </div>
                <div  className="hr-line-dashed">  </div>





                <div className="container" id="Tipo2">
                    <div className="row padding-bottom20">                    
                        <div className="col-sm-12"> 
                            <div className="affa-feature-img">
                                <img src="images/02Alfombraspraexteriores.jpg" alt="02Alfombraspraexteriores"/>                                
                            </div>
                        </div>
                    </div>       
                </div>
                <div  className="hr-line-dashed">  </div>

                 {/** foto2 * */}
                <div className="container">
                    <div className="row padding-bottom20" >
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="affa-col-txt">
                                    <img src="images/48100NomadHeavy1.jpg" alt="48100NomadHeavy1" />
                                    <img src="images/48100NomadHeavy2.jpg" alt="48100NomadHeavy2" />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="affa-feature-img">
                                    <img src="images/48100NomadHeavy4.jpg" alt="48100NomadHeavy4" />
                                    <img src="images/48100NomadHeavy3.jpg" alt="48100NomadHeavy3" />
                                </div>
                            </div>
                        </div>         
                    </div>
                </div>
                <div  className="hr-line-dashed">  </div>


                

                <div className="container">
                    <div className="row padding-bottom20" >
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="affa-col-txt">
                                    <img src="images/6GrandClassic1.jpg" alt="6GrandClassic1" />
                                    <img src="images/6GrandClassic2.jpg" alt="6GrandClassic2" />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="affa-feature-img">
                                    <img src="images/6GrandClassic4.jpg" alt="6GrandClassic4" />
                                    <img src="images/6GrandClassic3.jpg" alt="6GrandClassic3" />
                                </div>
                            </div>
                        </div>         
                    </div>
                </div>
                <div  className="hr-line-dashed">  </div>




            </div>        
           
        
        
        
            <div  className="padding-top80" id="tipos">
                

                

                

                <div className="container" id="Tipo3">
                    <div className="row padding-bottom20">                    
                        <div className="col-sm-12"> 
                            <div className="affa-feature-img">
                                <img src="images/03Alfombrasconlogos.jpg" alt="03Alfombrasconlogos"/>                                
                            </div>
                        </div>
                    </div>       
                </div>
                <div  className="hr-line-dashed">  </div>


                <div className="container"  id="Tipo4">
                    <div className="row padding-bottom20">                    
                        <div className="col-sm-12"> 
                            <div className="affa-feature-img">
                                <img src="images/04Lavadodealfombras01.jpg" alt="04Lavadodealfombras01"/>                                
                            </div>
                        </div>
                    </div>       
                </div>
                <div  className="hr-line-dashed">  </div>
                        
            </div>




            <div id="" className="">

                <div className="affa-feature-img">
                    <img src="images/FootherAlfombra.jpg" alt="FootherAlfombra"/>
                </div>
                
            </div>



            <div id="cotizar" className="">
            <div className="container">
                <div className="row padding-bottom20" >
                        <div className="row">
                            <div className="col-sm-6">
                            {enviado?
                                <div class="alert alert-success" role="alert">
                                <strong>Enviado!</strong> Enviado exitosamente
                                </div>
                                :
                                <div>
                                <h1>Completa el formulario!</h1>
                            <p>Para solicitar información, sucribete y recibiras por correo ofertas y promociones.</p>
                            <form   onSubmit={this.Cotizacion} className="affa-form-subscribe">
                                
                                <input type="text"
                                name="nombre" 
                                placeholder="Nombre"
                                onChange={this.nombrePersona}
                                className={error ?'error':''}
                                // ref={this.nombreRef} 
                                required 
                                />
                                <input type="text"
                                name="empresa" 
                                placeholder="Empresa o mensaje "
                                onChange={this.empresaPersona}
                                className={error ?'error':''}
                                // ref={this.empresaRef}  
                                required
                                />
                                <input type="email"
                                name="correo" 
                                placeholder="Dirección de correo...."
                                 onChange={this.correoPersona}
                                 className={error ?'error':''}
                                // ref={this.emailRef}  
                                required
                                />
                                <input type="text"
                                name="telefono" 
                                placeholder="Teléfono"
                                onChange={this.telefonoPersona}
                                className={error ?'error':''}
                                // ref={this.telefonoRef}  
                                required
                                />                                 
                                <input type="submit" name="Enviar" value="Solicitar cotizacion"/>
                            </form><br/>
                            </div>
                            }
                            
                            {
                                error ?
                                <div class="alert alert-warning" role="alert">
                                <strong>Atencion!</strong> todos lo campos son requeridos
                                </div>
                                :''
                            }
                            </div>
                            <div className="col-sm-6">
                                <figure><img src="images/FootherFormularioAlfombras.jpg" alt="FootherFormularioAlfombras" /></figure>
                            
                            </div>
                        </div>         
                </div>
                </div>
            </div>


            <div id="fooder" className="bg-img ">
        
                
                
            </div>




            
        

        
        </div>
        )
    }
}

export default Alfombras;